import * as React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
const SvgWarning = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    props,
    <path d="M3.88 19h16.24a.5.5 0 0 0 .43-.76L12.43 4.71a.51.51 0 0 0-.86 0L3.45 18.24a.5.5 0 0 0 .43.76ZM13 17h-2v-2h2v2Zm0-3h-2v-4h2v4Z" />
  )
export default SvgWarning
